import React from "react";
import { NamedIcon } from "./named-icon";
import type { TIconName } from "~/lib/icon-names";

const colorMap = {
  default: "text-purple-700",
  green: "text-green-700",
};

export interface InfoItem {
  icon: TIconName;
  color?: keyof typeof colorMap;
  label?: string;
  value?: string;
}

interface InfoListProps {
  items: InfoItem[];
}

export const InfoList = ({ items }: InfoListProps) => {
  return (
    <ul className="space-y-4">
      {items.map((item, index) => {
        return (
          <li key={index} className="flex items-center gap-2">
            <div className="flex w-6 shrink-0 items-center justify-center">
              <NamedIcon
                name={item.icon}
                className={`text-xl ${item.color ? colorMap[item.color] : colorMap.default}`}
              />
            </div>
            <div className="flex flex-col">
              {item.value && (
                <p className="text-text-secondary text-sm font-medium">
                  {item.value}
                </p>
              )}
              {item.label && (
                <p className="text-text-tertiary text-xs">{item.label}</p>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};
